import { render, staticRenderFns } from "./iatChoiceButton.vue?vue&type=template&id=f8e4b88e"
import script from "./iatChoiceButton.vue?vue&type=script&lang=js"
export * from "./iatChoiceButton.vue?vue&type=script&lang=js"
import style0 from "./iatChoiceButton.vue?vue&type=style&index=0&id=f8e4b88e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports